"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lceMapContent = exports.lceError = exports.lceContent = exports.lceFetching = exports.lceNotRequested = void 0;
const getDataOrPrevious_1 = require("./getDataOrPrevious");
const models_1 = require("./models");
/**
 * Returns an instance of @type NOT_REQUESTED. The returned instance is a frozen object
 * shared by all calls to this function.
 */
function lceNotRequested() {
    return models_1.LCE_NOT_REQUESTED;
}
exports.lceNotRequested = lceNotRequested;
/**
 * Returns an instance of @type IS_FETCHING, with optional previousState.
 * @param previousState Optional LCE value for previous state. Any previous content value will be carried through.
 */
function lceFetching(previousState) {
    const previousContent = getDataOrPrevious_1.getContentOrPrevious(previousState);
    if (previousContent) {
        return {
            type: models_1.LCEType.Fetching,
            previousContent,
        };
    }
    else {
        return models_1.LCE_IS_FETCHING;
    }
}
exports.lceFetching = lceFetching;
/**
 * Returns an instance of @type CONTENT with @param data.
 * @param data The data for the CONTENT
 * @param cacheTimeInMS Optional cache time in milliseconds. Set this to enable the utility functions such as @function getUnexpiredDataOrPrevious
 * @param lastFetched Optional date to set for fetched time. If not provided, this is set to the current time.
 */
function lceContent(data, cacheTimeInMS, lastFetched) {
    const lastFetchedDate = lastFetched ? new Date(lastFetched) : new Date();
    return {
        type: models_1.LCEType.Content,
        data,
        lastFetchedMS: lastFetchedDate.getTime(),
        cacheTimeInMS,
    };
}
exports.lceContent = lceContent;
/**
 * Returns an instance of @type ERROR.
 * @param error The error associated with fetching/hydrating the data.
 * @param previousState Optional previous state. Any previous content value will be carried through.
 */
function lceError(error, previousState) {
    const occurredOnDate = new Date();
    const occurredOnMS = occurredOnDate.getTime();
    const previousContent = getDataOrPrevious_1.getContentOrPrevious(previousState);
    if (previousContent) {
        return {
            type: models_1.LCEType.Error,
            error,
            occurredOnMS,
            previousContent,
        };
    }
    else {
        return {
            type: models_1.LCEType.Error,
            error,
            occurredOnMS,
        };
    }
}
exports.lceError = lceError;
/**
 * Builds an @type LCEMap of @type CONTENT, by creating a @type CONTENT instance for each value in @param data.
 * @param data Map of existing data to be set to @type CONTENT state.
 * @param cacheTimeInMS Optional cache time in milliseconds. Set this to enable the utility functions such as @function getUnexpiredDataOrPrevious
 * @param lastFetched Optional date to set for fetched time. If not provided, this is set to the current time.
 */
function lceMapContent(data, cacheTimeInMS, lastFetched) {
    const lastFetchedDate = lastFetched ? new Date(lastFetched) : undefined;
    const mappedData = {};
    for (let key of Object.keys(data)) {
        mappedData[key] = lceContent(data[key], cacheTimeInMS, lastFetchedDate);
    }
    return mappedData;
}
exports.lceMapContent = lceMapContent;
//# sourceMappingURL=factory.js.map